import type {
  DigitalAdChannel,
  IdPostAccountDto,
  IdPostCampaignDto,
  PostCampaignStatus,
  AdUnitDetailsDto,
  TaskDto,
  PositionsOverwritingOptions,
  TargetedDigitalAdUnitDto,
  TargetedUnaddressedMailingAdUnitDto,
} from '@/services/ws-post/src/main/resources/rest-api';

import type { BasePositionForm, PositionRouteParams } from 'src/modules/Positions/index.ts';
import type { PostPositionType, SavedPostCampaignRouteParams as BaseRouteParams } from 'src/modules/PostCampaign/index.ts';
import type { ColumnComponentProps } from 'src/types.ts';

export interface EditRouteParams {
  accountId?: IdPostAccountDto;
  status: PostCampaignStatus;
  campaignId?: IdPostCampaignDto;
}

export type SavedPostCampaignRouteParams = BaseRouteParams;

export type PositionsEditRouteParams = SavedPostCampaignRouteParams & Required<PositionRouteParams<PostPositionType>>;

export type FormSubmitType = 'save' | 'continue' | 'cancel';

export interface PostFormValues extends PositionsOverwritingOptions {
  actionType?: FormSubmitType;
}

/**
 * `null` item was added on the BE side as there is a problem with trimming common enum prefixes.
 * More info here: https://gitlab.audienzz.ch/audienzz/audienzz/-/merge_requests/20212#note_348078
 * While the problem is relevant we need a wrapper that removes the unnecessary element.
 */
export type PostDigitalAdChannel = Exclude<DigitalAdChannel, null>;

export interface PaginatedItems<TItem> {
  items: TItem[];
  total: number;
}

export interface AdUnitDetailsCellProps<TName extends string = string> extends ColumnComponentProps<TName> {
  advertisingUnit: AdUnitDetailsDto;
}

export interface TargetedAdUnitCellProps<TName extends string = string> extends ColumnComponentProps<TName> {
  advertisingUnit: TargetedUnaddressedMailingAdUnitDto | TargetedDigitalAdUnitDto;
}

export enum PreviewDisabledReason {
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  RECONCILIATION_REQUIRED = 'RECONCILIATION_REQUIRED',
  DIFFERENT_TAX_RATE = 'DIFFERENT_TAX_RATE',
  POSITIONS_EMPTY = 'POSITIONS_EMPTY',
}

export interface PositionFormWithTasks<PId> extends BasePositionForm<PId> {
  tasks: TaskDto[];
}
